// OK 17/10/2024

import { NewPwd, Persons } from "../interfaces";
import {  ip } from "../utils/setup";

const API_AUTH = `${ip}/api/Auth`;
const API_PWD = `${ip}/api/Pwds`;

// GET

export async function getCurrentUser() {
  try {
    const response = await fetch(`${API_AUTH}/current`, {
        credentials: "include",
        
    });
    if (response.ok) {
      const body: Persons[] = await response.json();
      return body;
    } else {
      return response.json();
    }
  } catch {
    return null;
  }
}

// GET ID

// POST

export async function signin(credentials: any) {
    const response = await fetch(API_AUTH, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
        credentials: "include",
    });

    if (response.ok) {
        return response.json();
    } else {
        if (response.status === 500) {
            throw new Error(
                `Connexion au serveur impossible, code serveur: ${response.status}`
            );
        } else if (response.status === 401) {
            throw new Error(`Login ou mot de passe incorrect`);
        } else if (response.status === 402) {
            throw new Error(`Accès refusé !`);
        } else {
            throw new Error(`Problème serveur, code serveur: ${response.status}`);
        }
    }
}


//PUT

export async function updatePwd(updatePwd: NewPwd) {
  const { globalError, ...restPwd } = updatePwd;
  const response = await fetch(`${API_PWD}/${restPwd.idPers}`, {
    method: "PUT",
      headers: { "Content-Type": "application/json",  },
      body: JSON.stringify(restPwd),
      credentials: "include"
  });
  if (response.ok) {
    return response.ok;
  } else {
    if (response.status === 500) {
      throw new Error(
        `Connexion au serveur impossible, code serveur: ${response.status}`
      );
    } else if (response.status === 401) {
      throw new Error(`Login ou mot de passe incorrect `);
    } else if (response.status === 402) {
      throw new Error(`Accès refusé ! `);
    } else {
      throw new Error(`Problème serveur, code serveur: ${response.status}`);
    }
  }
}

// DELETE

export async function signout() {
  const response = await fetch(API_AUTH, {
    method: "DELETE",
      credentials: "include",
      
  });
  if (response.ok) {
    document.cookie =
      "SynergiesTech=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  } else {
    console.error("Erreur lors de la déconnexion", response.statusText);
  }
}
